import { Component, Input } from '@angular/core';

@Component({
    selector: 'avatar',
    template: `
  <svg 
  viewBox="0 0 1000 1000"
  class="avatar" 
  [ngClass]="class"
  [ngStyle]="getColor()"><text
    x="50%"
    y="50%"
    dominant-baseline='central'
    text-anchor="middle"
    fill="rgba(255,255,255,0.7)"
    font-family="Helvetica, sans-serif"
    font-size="2500%"
  >{{getText()}}</text></svg>
  `,
    styles: [`
  .avatar {
    
  }
  `]

    //   styles: [`.avatar {max-width: 100%; height: auto; display: block;} `]

})
export class AvatarComponent {
    @Input() text: string;
    @Input() hash?: string;
    @Input() class?: string;

    public getColor() {
        if (!this.text) {
            return
        }

        let useString = this.text;
        if (this.hash && this.hash != "") {
            useString = this.hash;
        }

        let sum = 0;
        let i = 0;
        let len = useString.length;
        while (i < len) {
            sum += useString.charCodeAt(i);
            i++;
        }

        let colorIndex = Math.floor(sum) % 36 * 10
        // rotate
        // colorIndex = Math.abs(colorIndex - 55)
        //return {background: `hsl(${colorIndex},56%,53%)` }

        return {
            background: `radial-gradient(hsl(${colorIndex},56%,53%), hsl(${colorIndex},56%,23%) 120%)
      `,
        }
    }

    public getText() {
        if (!this.text) {
            return
        }

        let matches = this.text.split(' ');

        if (matches.length == 1) {
            return matches[0][0].toUpperCase();
        } else {
            return matches[0][0].toUpperCase() + matches[matches.length - 1][0].toUpperCase();
        }
    }
}
